import React from "react";
import { extractGuidanceForAttachment } from "../lib/extractGuidance";
import { extractIncomplete } from "./AttachmentChip";

/**
 * Composer hint when an incomplete attachment blocks full inspection.
 * No control that bypasses HOLD; only remove/replace then resend.
 */
export function ExtractRecoverBanner({ attachments, onReplaceFirst }) {
  const incomplete = (attachments || []).filter(extractIncomplete);
  if (!incomplete.length) return null;
  const first = incomplete[0];
  const g = extractGuidanceForAttachment(first);
  if (!g) return null;
  return (
    <div
      data-testid="extract-recover-banner"
      className="mb-2 rounded-lg border border-warn/40 bg-warn/10 px-3 py-2 text-xs text-slate-300"
    >
      <p className="font-semibold text-warn">{g.summary}</p>
      <p className="mt-1 text-slate-400">{g.detail}</p>
      {g.coverageLine ? (
        <p data-testid="extract-recover-coverage" className="mt-1 font-mono text-[10px] text-slate-500">
          {g.coverageLine}
        </p>
      ) : null}
      <p className="mt-1 text-slate-300">{g.recovery}</p>
      <p className="mt-1 font-mono text-[10px] uppercase tracking-wider text-slate-500">
        Tekst geëxtraheerd is niet inhoud geïnspecteerd. Geen omzeiling van HOLD.
      </p>
      {onReplaceFirst && (
        <button
          type="button"
          data-testid="extract-recover-replace-btn"
          onClick={onReplaceFirst}
          className="mt-2 rounded-lg border border-warn/50 bg-warn/15 px-2.5 py-1 font-mono text-[10px] font-bold uppercase tracking-wider text-warn hover:bg-warn/25"
        >
          Verwijder en nieuw bestand kiezen
        </button>
      )}
    </div>
  );
}
